<template>
    <div>
        <div v-if="!ctx" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-else>
            <c-panel title="IDENTIFICAÇÃO" titleIcon="fas fa-id-card">
                <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Escola">
                            <el-input :value="ctx.instituicao.nome" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Curso/Ano">
                            <el-input :value="ctx.curso ? ctx.curso.nome : '-'" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Turma">
                            <el-input :value="ctx.turma.nome" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Professor(a) regente">
                            <el-input :value="ctx.professor ? ctx.professor.nome : '— (não cadastrado)'" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período diagnóstico">
                            <el-input :value="ctx.periodo_diagnostico.descricao" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Data da aplicação">
                            <el-input v-model="dataAplicacao" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="ctx.gestao && ctx.gestao.length">
                    <el-col :xs="24">
                        <el-form-item label="Equipe gestora">
                            <div class="u-text-muted" style="font-size: 12px;">
                                <span v-for="g in ctx.gestao" :key="g.id" style="margin-right: 14px;">
                                    {{ g.nome }} <small>({{ funcaoNome(g.funcao) }})</small>
                                </span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                </el-form>
            </c-panel>

            <el-row :gutter="14">
                <el-col :xs="24" :md="16">
                    <c-panel :title="`ALUNOS (${alunos.length})`" titleIcon="fas fa-user-graduate">
                        <div v-if="!alunos.length" class="u-text-center u-mt-15" style="color: #909399;">
                            Nenhum aluno matriculado nesta turma.
                        </div>
                        <table v-else class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 50px;">Nº</th>
                                    <th>Aluno(a)</th>
                                    <th style="width: 230px;">Nível</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(a, i) in alunos" :key="a.aluno_id">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ a.nome }}</td>
                                    <td>
                                        <el-select v-model="a.nivel" placeholder="Selecione" clearable>
                                            <el-option v-for="n in niveisDisponiveis" :key="n.v" :label="n.l" :value="n.v"></el-option>
                                        </el-select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </c-panel>
                </el-col>

                <el-col :xs="24" :md="8">
                    <c-panel title="RESULTADOS EM TEMPO REAL" titleIcon="fas fa-chart-pie">
                        <table class="table-kpi">
                            <tr>
                                <td>Matriculados</td>
                                <td class="u-text-right"><b>{{ alunos.length }}</b></td>
                            </tr>
                            <tr>
                                <td>Lançados</td>
                                <td class="u-text-right"><b>{{ totalLancados }}</b></td>
                            </tr>
                            <tr>
                                <td>Ausentes</td>
                                <td class="u-text-right">{{ ausentes }} ({{ pct(ausentes) }}%)</td>
                            </tr>
                            <tr>
                                <td>Não Computados</td>
                                <td class="u-text-right">{{ naoComputados }} ({{ pct(naoComputados) }}%)</td>
                            </tr>
                            <tr style="border-top: 1px solid #ddd;">
                                <td><b>Realizaram</b></td>
                                <td class="u-text-right"><b>{{ realizaram }} ({{ pct(realizaram) }}%)</b></td>
                            </tr>
                        </table>

                        <h4 style="margin-top: 14px;">Por nível (sobre quem realizou)</h4>
                        <table class="table-kpi">
                            <tr v-for="n in niveisRealizaram" :key="n.v">
                                <td><span :style="`display:inline-block;width:10px;height:10px;background:${n.cor};margin-right:6px;`"></span>{{ n.l }}</td>
                                <td class="u-text-right">{{ contagem[n.v] || 0 }} ({{ pctRealizaram(contagem[n.v] || 0) }}%)</td>
                            </tr>
                        </table>
                    </c-panel>

                    <c-panel :title="`Taxa de Participação`" titleIcon="fas fa-chart-bar">
                        <div class="chart-box">
                            <bar-chart class="chart-canvas" :chart-data="chartParticipacao"></bar-chart>
                        </div>
                    </c-panel>

                    <c-panel :title="tituloGrafDistribuicao" titleIcon="fas fa-chart-bar">
                        <div class="chart-box">
                            <bar-chart class="chart-canvas" :chart-data="chartDistribuicao"></bar-chart>
                        </div>
                    </c-panel>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mt-15">
                <el-col :xs="24" class="u-text-right">
                    <el-button @click="voltar" plain>VOLTAR</el-button>
                    <el-button v-if="ctx.tabulacao && ctx.tabulacao.id" type="primary" plain @click="imprimir">IMPRIMIR</el-button>
                    <el-button v-if="podeEnviar" type="success" plain @click="enviar">ENVIAR PARA SUPERVISÃO</el-button>
                    <el-button v-if="!enviada" type="primary" plain @click="salvar(false)">SALVAR RASCUNHO</el-button>
                    <el-button v-if="!enviada" type="primary" @click="salvar(true)">FINALIZAR</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { TABULACAO_PARTICIPACAO_CORES, tabulacaoNiveisPorTipo } from '@/shared/constants'

const FUNCOES = { 9: 'Secretário', 11: 'Diretor', 12: 'Vice-Diretor', 13: 'Coordenador Pedagógico' }

export default {
    components: {
        cPanel: () => import('@/shared/c-panel/c-panel.vue'),
        BarChart: () => import('@/chart/BarChart')
    },
    props: {
        tipo: { type: String, required: true },
        turmaId: { type: [String, Number], required: true },
        periodoId: { type: [String, Number], required: true },
        voltarPara: { type: String, default: '' }
    },
    data: () => ({
        ctx: null,
        alunos: [],
        dataAplicacao: '',
        chartParticipacao: { labels: [], datasets: [] },
        chartDistribuicao: { labels: [], datasets: [] }
    }),
    computed: {
        niveisDisponiveis () { return tabulacaoNiveisPorTipo(this.tipo) },
        niveisRealizaram () {
            return this.niveisDisponiveis.filter(n => n.v !== 'nao_computado' && n.v !== 'ausente')
        },
        contagem () {
            const c = {}
            for (const n of this.niveisDisponiveis) c[n.v] = 0
            for (const a of this.alunos) {
                if (a.nivel && c[a.nivel] !== undefined) c[a.nivel]++
            }
            return c
        },
        totalLancados () { return this.alunos.reduce((s, a) => s + (a.nivel ? 1 : 0), 0) },
        ausentes () { return this.contagem.ausente || 0 },
        naoComputados () { return this.contagem.nao_computado || 0 },
        realizaram () { return this.totalLancados - this.ausentes - this.naoComputados },
        tituloGrafDistribuicao () {
            const ord = this.ctx && this.ctx.periodo_diagnostico ? this.ctx.periodo_diagnostico.ordem : ''
            const algarismo = { 1: 'I', 2: 'II', 3: 'III' }[ord] || ord
            const titulo = this.tipo === 'DESENHO' ? 'Diagnóstico de Desenho' : 'Diagnóstico de Escrita'
            return `${algarismo} ${titulo}`
        },
        podeEnviar () {
            return this.ctx && this.ctx.tabulacao && this.ctx.tabulacao.status === 2
        },
        enviada () {
            return this.ctx && this.ctx.tabulacao && this.ctx.tabulacao.status === 3
        }
    },
    mounted () { this.load() },
    methods: {
        funcaoNome (f) { return FUNCOES[f] || 'Servidor' },
        pct (n) {
            const t = this.alunos.length
            if (!t) return '0,0'
            return (100 * n / t).toFixed(1).replace('.', ',')
        },
        pctRealizaram (n) {
            const t = this.realizaram
            if (!t) return '0,0'
            return (100 * n / t).toFixed(1).replace('.', ',')
        },
        load () {
            this.ctx = null
            const url = `${this.$store.state.config.baseUrlApi}/api/tabulacao/getTurma/${this.turmaId}/${this.periodoId}/${this.tipo}`
            this.$axios.get(url, this.$store.getters.getHeaderAuth)
                .then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    this.ctx = r.data
                    this.alunos = (r.data.alunos || []).map(a => ({ ...a }))
                    this.dataAplicacao = r.data.tabulacao && r.data.tabulacao.data_aplicacao
                        ? this.$moment(r.data.tabulacao.data_aplicacao).format('DD/MM/YYYY')
                        : this.$moment().format('DD/MM/YYYY')
                    this.atualizarGraficos()
                })
                .catch(error => { this.$store.commit('throwException', error) })
        },
        atualizarGraficos () {
            // Participação
            const t = this.alunos.length || 1
            this.chartParticipacao = {
                labels: [this.ctx && this.ctx.turma ? this.ctx.turma.nome : ''],
                datasets: [
                    { label: 'Presentes', backgroundColor: TABULACAO_PARTICIPACAO_CORES.presentes, data: [+(100 * this.realizaram / t).toFixed(1)] },
                    { label: 'Ausentes', backgroundColor: TABULACAO_PARTICIPACAO_CORES.ausentes, data: [+(100 * this.ausentes / t).toFixed(1)] },
                    { label: 'Não Computados', backgroundColor: TABULACAO_PARTICIPACAO_CORES.nao_computados, data: [+(100 * this.naoComputados / t).toFixed(1)] }
                ]
            }
            // Distribuição (uma série por nível, com base no total que realizou)
            const base = this.realizaram || 1
            this.chartDistribuicao = {
                labels: [this.ctx && this.ctx.turma ? this.ctx.turma.nome : ''],
                datasets: this.niveisDisponiveis.map(n => ({
                    label: n.curto || n.l,
                    backgroundColor: n.cor,
                    data: [+(100 * (this.contagem[n.v] || 0) / base).toFixed(1)]
                }))
            }
        },
        salvar (finalizarApos) {
            const payload = {
                turma_id: this.turmaId,
                periodo_diagnostico_id: this.periodoId,
                tipo: this.tipo,
                data_aplicacao: this.dataAplicacao && this.$moment(this.dataAplicacao, 'DD/MM/YYYY', true).isValid()
                    ? this.$moment(this.dataAplicacao, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                alunos: this.alunos.map(a => ({ aluno_id: a.aluno_id, matricula_id: a.matricula_id, nivel: a.nivel }))
            }
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/tabulacao/salvar`, payload, this.$store.getters.getHeaderAuth)
                .then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    if (finalizarApos && r.data && r.data.id) {
                        this.finalizar(r.data.id)
                    } else {
                        window.eventBus.$emit('alert', { msg: 'Rascunho salvo com sucesso.', type: 'success' })
                        this.load()
                    }
                })
                .catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        },
        finalizar (id) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/tabulacao/finalizar/${id}`, {}, this.$store.getters.getHeaderAuth)
                .then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        this.load()
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Tabulação finalizada.', type: 'success' })
                    this.load()
                })
                .catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        },
        enviar () {
            const id = this.ctx && this.ctx.tabulacao ? this.ctx.tabulacao.id : null
            if (!id) return
            this.$msgbox.confirm('Confirmar envio desta tabulação para a supervisão? Após o envio, não será possível editar.', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => {
                    window.eventBus.$emit('loading', true)
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/tabulacao/enviarSupervisao/${id}`, {}, this.$store.getters.getHeaderAuth)
                        .then(r => {
                            window.eventBus.$emit('loading', false)
                            if (r.data && r.data.erro) {
                                window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                                return
                            }
                            window.eventBus.$emit('alert', { msg: 'Tabulação enviada para a supervisão.', type: 'success' })
                            this.load()
                        })
                        .catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
                }).catch(() => {})
        },
        imprimir () {
            const id = this.ctx && this.ctx.tabulacao ? this.ctx.tabulacao.id : null
            if (!id) return
            window.eventBus.$emit('loading', true)
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/tabulacao/imprimir/${id}`, this.$store.getters.getHeaderAuthExcel)
                .then(response => {
                    window.eventBus.$emit('loading', false)
                    const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.target = '_blank'
                    link.click()
                    window.URL.revokeObjectURL(link.href)
                })
                .catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        },
        voltar () {
            if (this.voltarPara) { this.$router.push(this.voltarPara); return }
            const rota = this.tipo === 'DESENHO' ? '/admin/tabulacao/coordenador/desenho' : '/admin/tabulacao/coordenador/base'
            this.$router.push(rota)
        }
    },
    watch: {
        alunos: { deep: true, handler () { this.atualizarGraficos() } }
    }
}
</script>

<style scoped>
.table-kpi { width: 100%; font-size: 12px; }
.table-kpi td { padding: 4px 0; }
.chart-box { height: 200px; position: relative; }
.chart-canvas { height: 100%; width: 100%; }
</style>
